import { createContext } from "react";

export const FormOneContext = createContext();

